(function () {
    'use strict';

    angular.module("EventListApp").constant('Constants', {
        EventID: 0,
        Lang: "",
        SearchTypes: {
            All: 1,
            ByParameters: 2,
            ByDate: 3,
            ByYear: 4,
        },
        ApiBaseUrl: 'https://api.eventact.com/o/v1/',

        LocalApiBaseUrl: getAppUrl() + 'api/EventsApi/',
        BaseUrl: getAppUrl(),
        AppURL: getAppUrl(),
        Folder: "",
        Texts: {
            ShareLinkTxt: " Hi I wanted to share this link with you \n "
            , ShareLinkTxtHe: "היי רציתי לשתף אותך בלינק הזה \n"
            , NoReply: 'noreplay@eventact.com'
            , EmailSubject: " new Email from "
        },
        // the section registry - values match the loadsection="..." attribute rendered on each <section>
        EventListSections: {
            Counter: "Counter"
            , Description: "Description"
            , Registration: "Registration"
            , News: "News"
            , CityInfo: "CityInfo"
            , Speakers: "Speakers"
            , SpeakersKeynote: "SpeakersKeynote"
            , SpeakersFeatured: "SpeakersFeatured"
            , Committee: "Committee"
            , Exhibitors: "Exhibitors"
            , Sponsors: "Sponsors"
            , Abstract: "Abstract"
            , Organizers: "Organizers"
            , Networking: "Networking"
            , ContactUs: "ContactUs"
            , Weather: "Weather"
            , Share: "Share"
            , Location: "Location"
            , Program: "Program"
            , SliderGallery: "SliderGallery"
            , SliderWelcome: "SliderWelcome"
            , Topics: "Topics"
            , Header: "Header"
            , TimeTable: "TimeTable"
            , ConferenceApp: "ConferenceApp"
            , FeaturedStories: "FeaturedStories"
            , FeaturedLinks: "FeaturedLinks"
            , Testimonials: "Testimonials"
            , FeaturedStats: "FeaturedStats"
            , SocialLinks: "SocialLinks"
            , FAQ: "FAQ"
            , Raw: 'Raw'
            , GeneralInformation: 'GeneralInformation'
            , VenueMap: 'VenueMap'
            , SpeakersAll: "SpeakersAll"
            , Divider: 'Divider'
            , Video: 'Video'
            , CountryMap: 'CountryMap'
            , ParticipatingCompanies: 'ParticipatingCompanies'
            , AllExhibitors: 'AllExhibitors'
        },
    });
})();